import React from "react";
import { Users, ShieldCheck, Mountain, Flame } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

const icons = [Users, ShieldCheck, Mountain, Flame];

export default function Pillars() {
  const { t } = useLang();
  return (
    <section className="section-pad relative bg-ink-surface">
      <div className="container-luxe">
        <Reveal className="mb-16 text-center">
          <p className="overline mb-4">{t.pillars.overline}</p>
          <h2 className="font-serif text-3xl font-light text-white sm:text-4xl lg:text-5xl">{t.pillars.title}</h2>
        </Reveal>

        <div className="grid grid-cols-2 gap-px overflow-hidden border border-gold/15 bg-gold/10 lg:grid-cols-4">
          {t.pillars.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div
                  data-testid={`pillar-${i}`}
                  className="group h-full bg-ink/80 backdrop-blur-xl p-5 transition-colors duration-500 hover:bg-ink-elevated sm:p-7 md:p-10"
                >
                  <Icon className="mb-4 text-gold transition-transform duration-500 group-hover:-translate-y-1 sm:mb-6 md:mb-7" size={28} strokeWidth={1.2} />
                  <h3 className="font-serif text-lg text-white sm:text-xl md:text-2xl">{item.t}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-white/55 sm:mt-3 sm:text-sm md:mt-4">{item.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
